// src/utils/functionURLs.js

const region = process.env.REACT_APP_FIREBASE_REGION || 'europe-west1';
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;

export const getFunctionUrl = (name) =>
  `https://${region}-${projectId}.cloudfunctions.net/${name}`;

// Prefer the standard derived function URL so a missing build env var in one
// environment does not silently send Stripe setup requests somewhere else.
export const STRIPE_ACCOUNT_INFO_URL =
  process.env.REACT_APP_STRIPE_ACCOUNT_INFO_URL || getFunctionUrl('getStripeAccountInfo');

export const CREATE_ACCOUNT_LINK_URL =
  process.env.REACT_APP_CREATE_ACCOUNT_LINK_URL || getFunctionUrl('createAccountLink');

export const UPDATE_STRIPE_PAYOUT_SCHEDULE_URL =
  process.env.REACT_APP_UPDATE_STRIPE_PAYOUT_SCHEDULE_URL || getFunctionUrl('updateStripePayoutSchedule');

export const START_XERO_CONNECT_URL =
  process.env.REACT_APP_START_XERO_CONNECT_URL || getFunctionUrl('startXeroConnect');

export const SAVE_XERO_CONFIG_URL =
  process.env.REACT_APP_SAVE_XERO_CONFIG_URL || getFunctionUrl('saveXeroConfig');

export const REFRESH_XERO_METADATA_URL =
  process.env.REACT_APP_REFRESH_XERO_METADATA_URL || getFunctionUrl('refreshXeroMetadata');

export const DISCONNECT_XERO_URL =
  process.env.REACT_APP_DISCONNECT_XERO_URL || getFunctionUrl('disconnectXero');

export const RUN_XERO_BACKFILL_URL =
  process.env.REACT_APP_RUN_XERO_BACKFILL_URL || getFunctionUrl('runXeroBackfill');

export const RUN_XERO_SYNC_NOW_URL =
  process.env.REACT_APP_RUN_XERO_SYNC_NOW_URL || getFunctionUrl('runXeroSyncNow');
